import React from 'react';
import { withErrorBoundary } from 'react-error-boundary';
import ErrorFallback from '@/pages/common/ErrorFallback/ErrorFallback';

export const errorBoundary = (component: React.ComponentType) =>
  withErrorBoundary(component, {
    FallbackComponent: ErrorFallback,
    onError: (err) => {
      console.error(err);
    }
  });
